// One request at a time; resume immediately when the user returns to the tab.
export function startVisiblePolling(load, interval, doc = document) {
  let stopped = false;
  let running = false;
  let timer;
  const run = async () => {
    clearTimeout(timer);
    if (stopped || running || doc.visibilityState === "hidden") return;
    running = true;
    try { await load(); } catch { /* The caller displays its own request error. */ }
    finally {
      running = false;
      if (!stopped && doc.visibilityState !== "hidden") timer = setTimeout(run, interval);
    }
  };
  const changed = () => {
    clearTimeout(timer);
    if (doc.visibilityState !== "hidden") void run();
  };
  doc.addEventListener("visibilitychange", changed);
  void run();
  return () => { stopped = true; clearTimeout(timer); doc.removeEventListener("visibilitychange", changed); };
}
